export const publicImageUrl = `https://storage.googleapis.com/sigmasofttech.appspot.com`;
